// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureToggleEnableDirective } from './directives/feature-toggle-enable.directive';
import { FeatureToggleDisableDirective } from '@coa/app/shared/feature-toggle/directives/feature-toggle-disable.directive';

@NgModule({
  declarations: [
    FeatureToggleEnableDirective,
    FeatureToggleDisableDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    FeatureToggleEnableDirective,
    FeatureToggleDisableDirective,
  ],
})
export class FeatureToggleModule {
}
